import { render, staticRenderFns } from "./UITrackDetails.vue?vue&type=template&id=23fd7b78"
import script from "./UITrackDetails.vue?vue&type=script&lang=ts"
export * from "./UITrackDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports